import { useState } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    nome: '',
    cognome: '',
    email: '',
    telefono: '',
    azienda: '',
    messaggio: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d6gs2iqu8ojn6g516jhg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          nome: '',
          cognome: '',
          email: '',
          telefono: '',
          azienda: '',
          messaggio: '',
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contatti" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          <div>
            <div className="inline-block px-4 py-2 rounded-full text-xs font-bold tracking-widest mb-6" style={{background:'#EEF2FF', color:'#1E3A5F'}}>
              CONTATTACI
            </div>
            <h2 className="text-5xl font-bold text-gray-900 mb-6 leading-tight" style={{ fontFamily: 'Inter, sans-serif' }}>
              Iniziamo a Costruire<br />
              il Tuo Team Ideale
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-12">
              Compila il form e ti ricontatteremo entro 24 ore per una consulenza gratuita personalizzata sulle tue esigenze HR.
            </p>

            <div className="space-y-6 mb-10">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-full flex-shrink-0" style={{background:'#EEF2FF'}}>
                  <i className="ri-mail-line text-xl" style={{color:'#1E3A5F'}}></i>
                </div>
                <div>
                  <div className="font-semibold text-gray-900 mb-1">Email</div>
                  <a href="mailto:pmresources.srl@gmail.com" className="text-gray-600 transition-colors">
                    pmresources.srl@gmail.com
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-full flex-shrink-0" style={{background:'#EEF2FF'}}>
                  <i className="ri-map-pin-line text-xl" style={{color:'#1E3A5F'}}></i>
                </div>
                <div>
                  <div className="font-semibold text-gray-900 mb-1">Sede</div>
                  <p className="text-gray-600">Viale Antonio Ciamarra 222, Roma</p>
                </div>
              </div>
            </div>

            {/* Google Maps */}
            <div className="w-full h-64 rounded-2xl overflow-hidden shadow-md border border-gray-100">
              <iframe
                title="PM Resources sede - Viale Antonio Ciamarra 222, Roma"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2972.0!2d12.5897!3d41.8219!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x13258b0e3e3e3e3f%3A0x0!2sViale+Antonio+Ciamarra+222%2C+00173+Roma+RM!5e0!3m2!1sit!2sit!4v1700000000000!5m2!1sit!2sit&q=Viale+Antonio+Ciamarra+222,+Roma"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>

          <div className="bg-gray-50 rounded-3xl p-10">
            <form onSubmit={handleSubmit} data-readdy-form id="contact-form">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label htmlFor="nome" className="block text-sm font-semibold text-gray-700 mb-2">
                    Nome *
                  </label>
                  <input
                    type="text"
                    id="nome"
                    name="nome"
                    value={formData.nome}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all"
                    placeholder="Il tuo nome"
                  />
                </div>
                <div>
                  <label htmlFor="cognome" className="block text-sm font-semibold text-gray-700 mb-2">
                    Cognome *
                  </label>
                  <input
                    type="text"
                    id="cognome"
                    name="cognome"
                    value={formData.cognome}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all"
                    placeholder="Il tuo cognome"
                  />
                </div>
              </div>

              <div className="mb-6">
                <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2">
                  Email *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all"
                  placeholder="tua@email.com"
                />
              </div>

              <div className="mb-6">
                <label htmlFor="telefono" className="block text-sm font-semibold text-gray-700 mb-2">
                  Telefono
                </label>
                <input
                  type="tel"
                  id="telefono"
                  name="telefono"
                  value={formData.telefono}
                  onChange={handleChange}
                  className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all"
                  placeholder="+39 123 456 7890"
                />
              </div>

              <div className="mb-6">
                <label htmlFor="azienda" className="block text-sm font-semibold text-gray-700 mb-2">
                  Azienda
                </label>
                <input
                  type="text"
                  id="azienda"
                  name="azienda"
                  value={formData.azienda}
                  onChange={handleChange}
                  className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all"
                  placeholder="Nome della tua azienda"
                />
              </div>

              <div className="mb-6">
                <label htmlFor="messaggio" className="block text-sm font-semibold text-gray-700 mb-2">
                  Messaggio *
                </label>
                <textarea
                  id="messaggio"
                  name="messaggio"
                  value={formData.messaggio}
                  onChange={handleChange}
                  required
                  maxLength={500}
                  rows={4}
                  className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all resize-none"
                  placeholder="Raccontaci le tue esigenze HR..."
                ></textarea>
                <div className="text-xs text-gray-500 mt-1 text-right">
                  {formData.messaggio.length}/500 caratteri
                </div>
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full px-6 py-4 text-white text-base font-semibold rounded-lg hover:opacity-90 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
                style={{background:'#1E3A5F'}}
              >
                {isSubmitting ? 'Invio in corso...' : 'Invia Richiesta'}
              </button>

              {submitStatus === 'success' && (
                <div className="mt-4 p-4 bg-green-50 border border-green-200 rounded-lg text-green-800 text-sm">
                  <i className="ri-check-line mr-2"></i>
                  Grazie! Ti ricontatteremo presto.
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="mt-4 p-4 bg-red-50 border border-red-200 rounded-lg text-red-800 text-sm">
                  <i className="ri-error-warning-line mr-2"></i>
                  Si è verificato un errore. Riprova.
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}